import { signal } from '@preact/signals-react';

export class ProfileStore {
  // Fields that change value throughout the lifecycle
  // of JSX components are marked with "signal"
  protected readonly disabledRules = signal(<Set<number>>new Set());
  protected readonly editableProfileName = signal(<string>'');
  protected readonly saveEnabled = signal(<boolean>false);

  // Fields that do not change value throughout the lifecycle
  // of JSX components are regular class members
  protected originalProfileName: string = '';
  protected editable: boolean = false;

  getEditableProfileName() {
    return this.editableProfileName.value;
  }

  setEditableProfileName(value: string | null) {
    this.editableProfileName.value = value ?? '';
    this.validateForm();
  }

  updateDisabledRulesState(checked: boolean, ruleNumber: number) {
    const newDisabledRules = new Set(this.disabledRules.value);
    if (checked) {
      newDisabledRules.delete(ruleNumber);
    } else {
      newDisabledRules.add(ruleNumber);
    }
    this.disabledRules.value = newDisabledRules;
    this.validateForm();
  }

  getDisabledRules() {
    return this.disabledRules.value;
  }

  getOriginalProfileName() {
    return this.originalProfileName;
  }

  isSaveEnabled() {
    return this.saveEnabled.value;
  }

  isEditable() {
    return this.editable;
  }

  protected validateForm() {
    this.saveEnabled.value = this.editableProfileName.value !== '';
  }
}
